import { render, staticRenderFns } from "./StoreyEdit.vue?vue&type=template&id=16fbdc3a&scoped=true"
import script from "./StoreyEdit.vue?vue&type=script&lang=js"
export * from "./StoreyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbdc3a",
  null
  
)

export default component.exports